export const VariableTypes = {
    // ============== Orders ============== 
    OrderDateAndHour: 'o.created_at',
    OrderValue: 'o.order_total',
    OrderDeliveryFee: 'o.delivery_total',
    OrderBrand: 'o.brand_id',
    OrderUnit: 'o.unit_id',
    OrderSourceData: 'o.source_id',
    OrderOriginSale: 'o.order_origin',
    OrderCity: 'o.delivery_city',
    OrderState: 'o.delivery_state',
    OrderCountry: 'o.delivery_country',
    OrderNeighborhood: 'o.delivery_region',
    OrderTemperature: 'w.temperature',
    OrderThermalSensation: 'w.feelslike',
    OrderMoisture: 'w.humidity',
    OrderClimaticFeature: 'w.condition',
    OrderYear: 'o.year',
    OrderDay: 'o.day',
    OrderWeek: 'o.week',
    OrderDayWeek: 'o.week_day',
    OrderMonth: 'o.month',
    // ============== Customers ============== 
    CustomerAge: 'c.age',
    CustomerDateAndHour: 'c.created_at',
    CustomerName: 'c.name',
    CustomerEmail: 'c.email',
    CustomerPhone: 'c.phone',
    CustomerDoc: 'c.doc',
    CustomerBirthday: 'c.birthdate',
    // CustomerGender: 'c.gender',
    CustomerLastAtt: 'c.updated_at',
    CustomerTotalSpend: 'c.sum_order',
    CustomerQuantityOrders: 'c.quantity',
    CustomerRFV: 'c.rfv_profile',
    CustomerAverageTicket: 'c.average_order',
    CustomerFrequencyOrders: 'c.order_frequency',
    CustomerLastOrder: 'c.last_conversion',
    CustomerMarketing: 'c.consent',
    CustomerHourRegistration: 'c.created_at_hour',
    CustomerDayRegistration: 'c.created_at_day',
    CustomerWeekRegistration: 'c.created_at_week',
    CustomerDayWeekRegistration: 'c.created_at_weekday',
    CustomerYearRegistration: 'c.created_at_year',
    CustomerMonthRegistration: 'c.created_at_month',
    CustomerDaysWithoutConversion: 'c.days_without_conversion',
    // ============== Coupons ============== 
    CouponDayAndHour: "cc.used_at",
    CouponCode: "cc.code",
    CouponType: "cc.type",
    CouponDiscount: "cc.value",
    CouponMinOrder: "cc.min_order",
    CouponDaysExp: "cc.expires_at_days_diff",
    CouponExpDate: "cc.expires_at",
    CouponExpDateReminder: "cc.remind_gain_date",
    CouponHour: "cc.used_at_hour",
    CouponDay: "cc.used_at_day",
    CouponWeek: "cc.used_at_week",
    CouponDayWeek: "cc.used_at_weekday",
    CouponMonth: "cc.used_at_month",
    CouponYear: "cc.used_at_year",
    // ============== Produtos ============== 
    ProductDayAndHour: "p.created_at",
    ProductSKU: "p.sku",
    ProductName: "p.name",
    ProductQuantity: "p.quantity",
    ProductHour: "p.created_at_hour",
    ProductValue: "p.total",
    ProductSize: "p.size_name",
    ProductCategory: "p.category_name",
    ProductYear: "p.created_at_year",
    ProductMonth: "p.created_at_month",
    ProductDay: "p.created_at_day",
    ProductWeek: "p.created_at_week",
    ProductDayWeek: "p.created_at_weekday",
    // ============== Perfis ============== 
    ProfileRFV: "pp.rfv",
    ProfileClimate: "pp.climate",
    ProfileMomentWeek: "pp.moment_week",
    ProfileMomentDay: "pp.moment_day",
    ProfileSeason: "pp.season",
    ProfileTemperature: "pp.temperature",
}

export const TypesVariable = Object.entries(VariableTypes).reduce((t, [key, value]) => ({ ...t, [value]: key }), {})